<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <nbn-order-primary-actions
        v-if="showPrimaryActionsAtTop"
        class="mb-4"
        @service-restoration="onTriggerServiceRestoration"
        @disconnect="onTriggerDisconnect"
        @edit="editForm"
        @correction="openCorrection"
        @resume="onTriggerActivate"
        @reversal="onTriggerServiceReversal"
        @withdraw="onTriggerCancel"
        @remove-configuration="onTriggerTransferLossRemove"
      />
      <nbn-order-item
        ref="nbnOrderItem"
        @emitNbnOrderItem="(payload, options) => setNbnOrderItem(payload, options || {})"
        :new-order="newOrder"
        :showNewNbnOrder="showNewNbnOrder"
        :isNewOrder="isNewOrder"
        :showConnectOutstandingFeature="showConnectOutstandingFeature"
        v-bind:wholesalerAccount="wholesalerAccount"
        v-bind:ServiceClass="ServiceClass"
        :filteredParties ="filteredParties"
      >
      </nbn-order-item>

      <div>
        <nbn-realized-resource
          ref="realizedResource"
          v-bind:productType="productType"
          v-bind:is-connect="true"
          v-bind:is-transfer="isTransferOrder"
          v-bind:has-ntd-id="hasNtdId"
          :newOrder="newOrder"
          @emitNbnRealizedResource="setNbnRealizedResource"
        >
        </nbn-realized-resource>
      </div>

      <div>
        <nbn-realized-service
          ref="realizedServices"
          v-bind:productType="productType"
          v-bind:is-connect="true"
          v-bind:CsaId="CsaId"
          :wholesalerAccount="wholesalerAccount"
          :newOrder="newOrder"
          @emitNbnRealizedService="setNbnRealizedService"
        >
        </nbn-realized-service>
      </div>

      <nbn-order-attachments
        ref="attachments"
        :custAuthRef="nbnOrder.customerAuthRef.trim()"
        :isOriginal="isOriginal"
      ></nbn-order-attachments>

      <nbn-ticket-form
        ref="ticketForm"
        :showNewNbnTicket="showNewNbnTicket"
        :fromOrderView="fromOrderView"
        :technologyType="nbnOrder.productType"
        :nbnOrderId="nbnOrder.nbnOrderId"
        @closeDialog="closeTicketForm()"
      ></nbn-ticket-form>

      <div class="text-right mb-7">
        <v-btn
          v-if="!isOriginal"
          class="primary"
          :disabled="
            isOriginal ||
              isPendingServiceability ||
              isReferenceInvalid ||
              invalid ||
              isRadiusExisting ||
              (!hasActiveServices &&
                nbnOrder.orderType == 'Transfer' &&
                isCpiAvailable)
          "
          @click="submit"
          >Submit</v-btn
        >
      </div>
    </ValidationObserver>
    <confirm-action
      :dialog="cancelDialog"
      :text="'Are you sure you want to cancel this nbn order?'"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="cancelNbnOrder"
    ></confirm-action>

    <confirm-action
      :dialog="disconnectDialog"
      :text="'Are you sure you want to disconnect this nbn service?'"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="disconnectNbnOrder"
    ></confirm-action>

    <confirm-action
      :dialog="activateDialog"
      :text="
        'Are you sure you want to activate this nbn service? Connect will send this order to NBN'
      "
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="activateHoldOrder"
    ></confirm-action>

    <confirm-action
      :dialog="transferLossRemoveDialog"
      :text="'Are you sure you want to remove this service from Usher Only?'"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="removeServiceFromUsher"
    ></confirm-action>
    <nbn-edit-form @closeForm="closeForm()"> </nbn-edit-form>
    <v-dialog v-model="showCorrectionForm" width="1200" persistent scrollable>
      <nbn-order-correction-form
        v-if="showCorrectionForm"
        :order="nbnOrderRecord"
        @close="closeCorrection"
        @corrected="onOrderCorrected"
      ></nbn-order-correction-form>
    </v-dialog>
  </div>
</template>

<script>
import NbnEditForm from "@/components/orderQualification/nbn-edit-form";
import NbnOrderCorrectionForm from "@/components/orderQualification/nbn-order-correction-form";
import NbnOrderPrimaryActions from "@/components/orderQualification/nbn-order-primary-actions";
import { wholesalerUsesContractTerm } from "../../utils/wholesaler";
import { canBeDispute } from "@/utils/nbn-reversal";
import {
  applyNtdRealizedResource,
  getNtdReplaceReason,
  isFibreProductType,
  normalizeFixedWirelessNtdType,
  NTD_MODIFICATION_OPTIONS,
  resolveExistingNtdId,
  resolveProductOffering,
  resolveOnSiteNtdId
} from "@/constants/nbn-order-item-constants";
export default {
  name: "OrderQualificationForm",
  components: { NbnEditForm, NbnOrderCorrectionForm, NbnOrderPrimaryActions },
  props: {
    isNewOrder: { type: Boolean },
    wholesalerAccount: { type: Number },
    newOrder: { type: Object },
    showNewNbnOrder: { type: Boolean, required: true },
    filteredParties: { type: Array},
    showPrimaryActionsAtTop: { type: Boolean, default: true },
  },
  data: () => ({
    result: {
      suburb: "",
      state: "",
      postCode: "",
      streetAddress: ""
    },
    fromOrderView: true,
    cancelDialog: false,
    disconnectDialog: false,
    showCorrectionForm: false,
    activateDialog: false,
    transferLossRemoveDialog: false,
    CsaId: "",
    search: null,
    streetAddress: "",
    longitude: "",
    latitude: "",
    gnafId: "",
    withData: false,
    queryAddress: [],
    showDialog: false,
    invalidItems: [],
    isInvalid: false,
    title: "",
    isValidated: false,
    checkType: "nbn",
    enableSubmit: true,
    disableRadio: false,
    address5gSq: {},
    processCount: 0,
    // newOrder:{},
    orderItem: {},
    realizedResource: {},
    realizedService: {},
    isConnectOrder: true,
    isTransferOrder: false,
    isTransitionOrder: false,
    hasNtdId: false,
    fileList: [],
    attachments: [],
    cvcId: "",
    ServiceClass: "",
    isRadiusExisting: false,
    showNewNbnTicket: false
  }),
  mounted() {
    let vm = this;
    vm.$refs.ticketForm.setWholesaler(vm.wholesalerAccount);
  },
  methods: {
    submit() {
      let vm = this;
      if (vm.nbnOrder) {
        vm.orderItem = Object.assign({}, vm.orderItem, {
          ntdModifications: vm.nbnOrder.ntdModifications,
          ntdType: vm.nbnOrder.ntdType,
          ntdId: vm.nbnOrder.ntdId,
          productType: vm.orderItem.productType || vm.nbnOrder.productType,
          orderType: vm.orderItem.orderType || vm.nbnOrder.orderType
        });
      }
      let payload = {};
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;

      vm.$refs.observer.validate().then(result => {
        if (result) {
          if (
            vm.orderItem.orderType === "Connect" ||
            vm.orderItem.orderType === "Transfer" ||
            vm.orderItem.orderType === "Transition"
          ) {
            payload = {
              order: {
                orderType: "Connect",
                externalId:
                  vm.orderItem.customerAuthRef !== null
                    ? vm.orderItem.customerAuthRef
                    : "",
                relatedPlace: {
                  id: vm.orderItem.locationId
                },
                productOffering: vm.getProductOffering(),
                orderItem: vm.getOrderItem(),
                realizedResource: vm.getRealizedResource(),
                realizedService: vm.getRealizedService()
              }
            };
            if (vm.productType === "Enterprise Ethernet") {
              payload.order.siteAccess = {
                inductionRequired: vm.orderItem.inductionRequired,
                securityClearance: vm.orderItem.securityClearance,
                notes: vm.orderItem.notes,
                tradingName: vm.orderItem.tradingName,
                heritageSite: vm.orderItem.heritageSite
              };
            }

            if (vm.orderItem.endUserType === "Business") {
              payload.order.relatedParty =
                vm.orderItem.partyId.value === undefined
                  ? [{ id: vm.orderItem.partyId }]
                  : [{ id: vm.orderItem.partyId.value }];
            }
            if (
              vm.orderItem.appointmentId != null &&
              vm.orderItem.appointmentId !== ""
            ) {
              payload.order.appointment = { id: vm.orderItem.appointmentId };
            }

            payload.isFibreSQ = vm.orderItem.isFibreConnect;
            payload.WholesalerAccount = vm.wholesalerAccount;
            payload.ContactFirstname = vm.orderItem.contactFirstname;
            payload.ContactSurname = vm.orderItem.contactSurname;
            payload.ContactNumber = vm.orderItem.contactNumber;
            payload.CustomerFirstname = vm.orderItem.customerFirstname;
            payload.CustomerSurname = vm.orderItem.customerSurname;
            payload.CustomerEmail = vm.orderItem.customerContactEmail;
            payload.CustomerContactNumber = vm.orderItem.customerContactNumber;
            payload.CustomerRef = vm.orderItem.customerRef;
            payload.CustomerAuthRef =
              vm.orderItem.customerAuthRef !== null
                ? vm.orderItem.customerAuthRef.trim()
                : "";
            payload.ProductType = vm.orderItem.productType;
            payload.OrderType = vm.orderItem.orderType;
            payload.CustomerAuthDate = today;
            payload.BandwidthProfile = vm.realizedService.bandwidthProfile;
            payload.ContractTerm = wholesalerUsesContractTerm(
              vm.wholesalers,
              vm.wholesalerAccount
            )
              ? vm.realizedService.contractTerm
              : null;
            payload.StaticIP = vm.orderItem.staticIP;
            payload.ShippingType = vm.orderItem.shippingType;
            payload.ShippingAddress = vm.orderItem.shippingAddress;
            payload.AuthToLeave = vm.orderItem.authToLeave;
            payload.HoldOrder = false;
            payload.SimRequired = false;
            payload.HardwareRequired = false;
            payload.IsConnectOutstanding =
              vm.orderItem.orderType === "Transfer" &&
              (vm.featureFlags.sog6974
                ? vm.showConnectOutstandingFeature
                : vm.isInternalWholesaler)
                ? vm.orderItem.isConnectOutstanding
                : false;
            payload.NtdModifications =
              vm.nbnOrder.ntdModifications || vm.orderItem.ntdModifications;

            if (vm.featureFlags.sog6788) {
              payload.ServiceId = payload.IsConnectOutstanding
                ? ""
                : vm.orderItem.serviceId;
            } else {
              payload.ServiceId = payload.IsConnectOutstanding
                ? ""
                : vm.orderItem.avcId;
            }

            if (vm.featureFlags.sog5822 && vm.isLayer3) {
              payload.IsIPoE = vm.orderItem.isIpoe;
            } else {
              payload.IsIPoE = false;
            }
            if (vm.orderItem.staticIP && vm.orderItem.ipRange !== undefined) {
              payload.IpRange = vm.orderItem.ipRange;
            }
            if (vm.featureFlags.sog4117) {
              payload.NbnAssureRequired =
                vm.orderItem.nbnAssureRequired === "Yes";
              if (payload.NbnAssureRequired) {
                payload.NbnAssure = vm.orderItem.nbnAssureOption;
              }
              payload.SimRequired = vm.orderItem.simRequired === "Yes";
              if (payload.SimRequired) {
                payload.simDeliveryAddress = vm.orderItem.simAddress;
              } else {
                payload.usim = vm.orderItem.usim;
              }

              payload.HardwareRequired =
                vm.orderItem.hardwareRequired === "Yes";
              payload.HoldOrder = false;

              if (payload.HardwareRequired) {
                payload.HardwareModem = vm.orderItem.hardwareOption;
                payload.HardwareDeliveryAddress = vm.orderItem.hardwareAddress;
                payload.HoldOrder = true;
                if (vm.orderItem.sameHardwareContact) {
                  payload.HardwareDeliveryContactName =
                    vm.orderItem.customerFirstname +
                    " " +
                    vm.orderItem.customerSurname;
                  payload.HardwareDeliveryContactNumber =
                    vm.orderItem.customerContactNumber;
                } else {
                  payload.HardwareDeliveryContactName =
                    vm.orderItem.hardwareContactName;
                  payload.HardwareDeliveryContactNumber =
                    vm.orderItem.hardwareContactNumber;
                }
              }

              if (
                vm.orderItem.scheduledDateTime != null &&
                vm.orderItem.scheduledDateTime != ""
              ) {
                payload.scheduledDateTime = vm.orderItem.scheduledDateTime;
                payload.HoldOrder = true;
              }

              if (vm.orderItem.connectionDateRequire == "Held") {
                payload.HoldOrder = true;
              }
            }

            if (
              vm.orderItem.installationWorkforce !== undefined &&
              vm.orderItem.installationWorkforce === "NBN Co Install End User"
            ) {
              payload.ShippingContact = {
                DeliveryFirstName: vm.orderItem.contactFirstname,
                DeliveryLastName: vm.orderItem.contactSurname,
                DeliveryNumber: vm.orderItem.contactNumber,
                DeliveryEmail: vm.orderItem.contactEmail
              };
              payload.order.dispatchDetails = {
                authorityToLeave: vm.orderItem.authToLeave,
                deliveryContact: {
                  contactName:
                    vm.orderItem.contactFirstname +
                    " " +
                    vm.orderItem.contactSurname,
                  contactType: "End User",
                  phoneNumber: vm.orderItem.contactNumber,
                  emailAddress: vm.orderItem.contactEmail
                }
              };

              if (vm.orderItem.shippingType === "Alternate Address") {
                payload.order.dispatchDetails.deliveryToAddress = {
                  addressLine1: vm.orderItem.shippingAddress.addressLine,
                  addressLine2: "",
                  addressLine3: "",
                  localityName: vm.orderItem.shippingAddress.suburb,
                  stateTerritoryCode: vm.orderItem.shippingAddress.state,
                  postCode: vm.orderItem.shippingAddress.postcode
                };
              } else {
                var addressLineParts = vm.sqNbnResult.address.formattedAddress.split(
                  ","
                );
                let addressLine = addressLineParts
                  .slice(0, -2)
                  .join(",")
                  .trim();
                payload.order.dispatchDetails.deliveryToAddress = {
                  addressLine1: addressLine,
                  addressLine2: "",
                  addressLine3: "",
                  localityName: vm.sqNbnResult.address.localityName,
                  stateTerritoryCode: vm.sqNbnResult.address.stateTerritoryCode,
                  postCode: vm.sqNbnResult.address.postcode
                };
              }
            }

            if (vm.$refs.nbnOrderItem.checkType === "Earliest") {
              payload.RequireEarliestAppointment = true;
            } else {
              payload.RequireEarliestAppointment = false;
            }

            if (
              vm.orderItem.radiusUsername !== null &&
              vm.orderItem.radiusUsername !== "" &&
              vm.isLayer3
            ) {
              payload.RadiusUsername = vm.orderItem.radiusUsername;
              payload.RadiusPassword = vm.orderItem.radiusPassword;
            } else if (
              (vm.orderItem.existingRadiusUsername !== null ||
                vm.orderItem.existingRadiusUsername !== "") &&
              vm.isLayer3
            ) {
              payload.ExistingRadiusUsername =
                vm.orderItem.existingRadiusUsername;
              payload.ExistingRadiusPassword =
                vm.orderItem.existingRadiusPassword;
            } else {
              payload.RadiusUsername = null;
              payload.RadiusPassword = null;
            }

            if (vm.realizedResource.portId != null) {
              payload.PortId = vm.realizedResource.portId;
            } else {
              payload.PortId = "1";
            }

            if (vm.orderItem.orderType === "Transfer") {
              payload.RequireEarliestAppointment = false;
              payload.order.orderItem.product.customerAuthorityDate = today;
              payload.order.orderItem.product.transferType = "Service Transfer";
              payload.order.orderItem.product.localNumberPorting = "No";
              if (vm.realizedResource.fromPortId != null) {
                payload.order.orderItem.product.overlapPeriod = 4;
                if (
                  vm.realizedResource.fromPortId === vm.realizedResource.portId
                ) {
                  payload.order.orderItem.product.overlapPeriod = 0;
                } else {
                  payload.order.realizedResource[1].product.fromPortId =
                    vm.realizedResource.fromPortId;
                }
              }
            }

            if (
              vm.orderItem.orderType !== "Transfer" &&
              ((vm.orderItem.replaceNtd !== null && vm.orderItem.replaceNtd) ||
              vm.nbnOrder.ntdModifications === "REPLACE SELECTED NTD" ||
              vm.orderItem.ntdId === "NTD Installation Required")
            ) {
              const onSiteNtdId = resolveOnSiteNtdId(
                vm.orderItem.ntdId,
                vm.orderItem.existingNtdId || vm.nbnOrder.existingNtdId,
                vm.sqNbnResult?.sq?.siteRestriction?.supportingResource
              );
              const replaceReason = getNtdReplaceReason(onSiteNtdId);
              if (replaceReason) {
                payload.order.reasonCode = replaceReason;
              }
            }

            if (vm.isNewOrder) {
              vm.createNbnOrderAsync(payload).then(data => {
                if (this.$refs.attachments.attachments.length > 0) {
                  vm.uploadFiles({
                    customerAuthRefs: data.data.externalId,
                    files: this.$refs.attachments.attachments
                  });
                }
                vm.setFibreCheckbox(false);
                vm.$emit("showCreatedOrderResult", data);
              });
            } else {
              vm.productQualification(payload).then(data => {
                vm.$emit("showOrderResultSection", data);
              });
            }
          } else if (vm.orderItem.orderType === "disconnect") {
            payload = {
              order: {
                orderType: "Disconnect",
                externalId:
                  vm.orderItem.customerAuthRef !== null
                    ? vm.orderItem.customerAuthRef
                    : "",
                orderItem: {
                  action: "DELETE",
                  product: {
                    id: vm.orderItem.productId
                  }
                }
              }
            };
            vm.createNbnOrderAsync(payload).then(data => {
              vm.uploadFiles({
                customerAuthRefs: data.data.externalId,
                files: this.$refs.attachments.attachments
              });
              vm.setFibreCheckbox(false);
              vm.$emit("showCreatedOrderResult", data);
            });
          }
        }
      });
    },
    activateHoldOrder(args) {
      let vm = this;
      let payload = {};
      payload.nbnOderId = vm.nbnOrder.id;
      if (args) {
        vm.activateHoldOrderAsync(payload)
          .then(data => {
            vm.activateDialog = false;
            vm.closeForm();
          })
          .catch(() => {});
      } else {
        vm.activateDialog = false;
      }
    },
    cancelNbnOrder(args) {
      let vm = this;
      if (args) {
        let payload = {};
        payload.nbnOrderId = vm.nbnOrder.nbnOrderId;
        payload.id = vm.nbnOrder.id;
        vm.cancelNbnOrderAsync(payload)
          .then(data => {
            vm.cancelDialog = false;
            vm.closeForm();
          })
          .catch(() => {});
      } else {
        vm.cancelDialog = false;
      }
    },
    disconnectNbnOrder(args) {
      let vm = this;
      if (args) {
        let order = {
          orderType: "Disconnect",
          // externalId: "ABC-123",
          externalId:
            vm.nbnOrder.customerAuthRef !== null
              ? vm.nbnOrder.customerAuthRef
              : "",
          orderItem: {
            action: "DELETE",
            product: {
              id: vm.nbnOrder.productId != null ? vm.nbnOrder.productId : ""
            }
          }
        };

        let payload = {
          order: order,
          nbnOrderId: vm.nbnOrder.nbnOrderId
        };

        vm.disconnectNbnServiceAsync(payload)
          .then(data => {
            vm.disconnectDialog = false;
            vm.closeForm();
          })
          .catch(() => {});
      } else {
        vm.disconnectDialog = false;
      }
    },
    removeServiceFromUsher(args) {
      let vm = this;
      if (args) {
        let payload = {
          avdid: vm.nbnOrder.avcId,
          orderId: vm.nbnOrder.nbnOrderId,
          id: vm.nbnOrder.id
        };
        vm.removeServiceFromUsherAsync(payload)
          .then(data => {
            vm.transferLossRemoveDialog = false;
            vm.closeForm();
          })
          .catch(() => {});
      } else {
        vm.transferLossRemoveDialog = false;
      }
    },
    updateLocationId(locationId) {
      let vm = this;
      vm.$refs.nbnOrderItem.updateLocationId(locationId);
    },
    getProductOffering() {
      let vm = this;
      return resolveProductOffering(
        vm.orderItem.productType,
        vm.orderItem.productTemplate,
        vm.featureFlags
      );
    },
    getOrderItem() {
      let vm = this;
      if (vm.orderItem.productType === "Fixed Wireless") {
        let productSpecification = {
          action: "ADD",
          product: {
            productSpecification: {
              id: "NWAS",
              version: "2.0.0",
              specificationType: "Product Specification"
            },
            priorityAssist: "No",
            informedConsent: "Yes",
            endUserType:
              vm.orderItem.endUserType === null ||
              vm.orderItem.endUserType === undefined ||
              vm.orderItem.endUserType === ""
                ? "Residential"
                : vm.orderItem.endUserType
          }
        };
        if (
          vm.orderItem.appointmentId != null &&
          vm.orderItem.orderType !== "Transfer" &&
          vm.orderItem.installationWorkforce !== undefined
        ) {
          productSpecification.product.installationWorkforce =
            vm.orderItem.installationWorkforce;
        }

        return productSpecification;
      } else if (vm.orderItem.productType === "HFC") {
        let productSpecification = {
          action: "ADD",
          product: {
            productSpecification: {
              id: "NHAS",
              version: "5.1",
              specificationType: "Product Specification"
            },
            priorityAssist: "No",
            informedConsent: "Yes",
            endUserType:
              vm.orderItem.endUserType === null ||
              vm.orderItem.endUserType === undefined ||
              vm.orderItem.endUserType === ""
                ? "Residential"
                : vm.orderItem.endUserType,
            orderSla: "Standard"
          }
        };

        if (
          vm.orderItem.orderType !== "Transfer" &&
          vm.orderItem.installationWorkforce !== undefined
        ) {
          productSpecification.product.installationWorkforce =
            vm.orderItem.installationWorkforce;
        }

        return productSpecification;
      } else if (vm.orderItem.productType === "Enterprise Ethernet") {
        return {
          action: "ADD",
          product: {
            productSpecification: {
              id: "EEAS",
              version: "1.0.0",
              specificationType: "Product Specification"
            },
            afterHoursSiteVisit: vm.orderItem.afterHoursSiteVisit,
            contractTerm: {
              amount: vm.orderItem.contractTerm.split(" ")[0],
              unit: "Month"
            },
            serviceRestorationSla: vm.orderItem.serviceRestorationSla
          }
        };
      } else if (
        vm.orderItem.productType === "FTTC" ||
        vm.orderItem.productType === "FTTB" ||
        vm.orderItem.productType === "FTTN"
      ) {
        let productSpecification = {
          action: "ADD",
          product: {
            productSpecification: {
              id: "NCAS",
              version: "1.0",
              specificationType: "Product Specification"
            },
            priorityAssist: "No",
            endUserType:
              vm.orderItem.endUserType === null ||
              vm.orderItem.endUserType === undefined ||
              vm.orderItem.endUserType === ""
                ? "Residential"
                : vm.orderItem.endUserType,
            orderSla: "Standard"
          }
        };

        if (
          vm.orderItem.orderType !== "Transfer" &&
          vm.orderItem.installationWorkforce !== undefined &&
          vm.orderItem.installationWorkforce !== ""
        ) {
          productSpecification.product.installationWorkforce =
            vm.orderItem.installationWorkforce;
        } else if (
          (vm.orderItem.appointmentId != null ||
            vm.$refs.nbnOrderItem.checkType === "Earliest") &&
          vm.orderItem.orderType !== "Transfer"
        ) {
          productSpecification.product.installationWorkforce =
            vm.orderItem.installationWorkforce !== undefined &&
            vm.orderItem.installationWorkforce !== ""
              ? vm.orderItem.installationWorkforce
              : "NBN Co Install";
        }

        if (
          (vm.orderItem.productType === "FTTN" &&
            productSpecification.product.installationWorkforce ===
              "NBN Co Install") ||
          (vm.orderItem.productType === "FTTN" &&
            vm.orderItem.orderType === "Transition") ||
          (vm.orderItem.productType === "FTTB" &&
            vm.orderItem.orderType !== "Transfer")
        ) {
          productSpecification.product.installationOptionsJumpering = "Yes";

          productSpecification.product.installationOptionsCentralSplitter =
            "No";
        }

        return productSpecification;
      } else if (isFibreProductType(vm.orderItem.productType)) {
        let productSpecification = {
          action: "ADD",
          product: {
            productSpecification: {
              id: "NFAS",
              version: "1.0",
              specificationType: "Product Specification"
            },
            priorityAssist: "No",
            batteryBackupService: "No",
            informedConsent: "Yes",
            endUserType:
              vm.orderItem.endUserType === null ||
              vm.orderItem.endUserType === undefined ||
              vm.orderItem.endUserType === ""
                ? "Residential"
                : vm.orderItem.endUserType
          }
        };

        if (
          vm.orderItem.appointmentId != null &&
          vm.orderItem.orderType !== "Transfer" &&
          vm.orderItem.installationWorkforce !== undefined
        ) {
          productSpecification.product.installationWorkforce =
            vm.orderItem.installationWorkforce;
        }

        return productSpecification;
      }

      return null;
    },
    setCsaId(csaId) {
      let vm = this;
      vm.CsaId = csaId;
      vm.setCvc();
    },
    setServiceClass(sc) {
      let vm = this;
      vm.ServiceClass = sc;
    },
    closeForm() {
      let vm = this;
      vm.$emit("closeDialog");
    },
    closeTicketForm() {
      let vm = this;
      vm.showNewNbnTicket = false;
    },
    setCvc() {
      let vm = this;
      const iseekAccountNumber = 61377;
      if (vm.CsaId !== null && vm.CsaId !== "") {
        var payload = {
          csaId: vm.CsaId,
          isVonexNetwork: true
        };
        if (vm.wholesalerAccount == iseekAccountNumber) {
          payload.isVonexNetwork = false;
        }
        vm.getCvcIds(payload).then(data => {
          vm.cvcId = data.cvcId;
        });
      }
    },
    isServiceReadyForTransfer(jsonData) {
      if (!jsonData || !jsonData.sq || !jsonData.sq.siteRestriction) {
        return false;
      }

      const siteRestriction = jsonData.sq.siteRestriction;
      const supportingTechnology = siteRestriction.supportingTechnology;
      const supportingResource = siteRestriction.supportingResource;

      // Extract required fields
      const serviceabilityClass = parseInt(
        supportingTechnology?.serviceabilityClass || "0",
        10
      );
      const uniPortStatus =
        supportingResource?.[0]?.uniPortD?.map(port => port.status) || [];
      const serviceabilityStatus = siteRestriction.serviceabilityStatus;
      const migrationFlag =
        siteRestriction.supportingRelatedLocationFeatures?.migrationFlag;

      // Define rules for readiness
      const readyServiceabilityClasses = [3, 10]; // Classes ready for transfer
      const uniPortUsed = uniPortStatus.includes("Used"); // At least one port is used
      const isServiceable = serviceabilityStatus === "Serviceable";
      const isInService = migrationFlag === "ISS"; // In-Service flag

      // Check readiness
      const isReady =
        readyServiceabilityClasses.includes(serviceabilityClass) &&
        uniPortUsed &&
        isServiceable &&
        isInService;

      // Return result
      return isReady;
    },
    isFttc(_sq) {
      return _sq.sqv3
        ? _sq.sqv3.siteRestriction[0].supportingTechnology
            .primaryAccessTechnology === "Fibre To The Curb"
        : false;
    },
    isFttn(_sq) {
      return _sq.sqv3
        ? _sq.sqv3.siteRestriction[0].supportingTechnology
            .primaryAccessTechnology === "Fibre To The Node"
        : false;
    },
    isFttb(_sq) {
      return _sq.sqv3
        ? _sq.sqv3.siteRestriction[0].supportingTechnology
            .primaryAccessTechnology === "Fibre To The Building"
        : false;
    },
    setDefaultAuthDate() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const yyyy = yesterday.getFullYear();
      const mm = String(yesterday.getMonth() + 1).padStart(2, "0");
      const dd = String(yesterday.getDate()).padStart(2, "0");

      const formattedDate = `${yyyy}-${mm}-${dd}`;
      return formattedDate;
    },
    isTransferred(sqV3) {
      try {
        const vm = this;
        const siteRestrictions = sqV3.siteRestriction || [];
        const rsp = process.env.NODE_ENV == "production" ? "0400" : "0615";
        // Flatten all supportingProducts from all siteRestrictions
        const allSupportingProducts = siteRestrictions
          .flatMap(sr => sr.supportingProduct || [])
          .filter(x => x.id == vm.nbnOrder.productId);
        // Check if any supportingProduct has serviceProviderId '0400'
        const isHomeRSP = allSupportingProducts.some(
          prod => prod.serviceProviderId === rsp
        );

        return !isHomeRSP;
      } catch (err) {
        return false;
      }
    },
    async onTriggerServiceReversal() {
      let vm = this;
      if (canBeDispute(vm.transferredDate)) {
        try {
          const customerAuthorityDate = vm.setDefaultAuthDate();

          let result = await vm.enhanceServiceQualificationNbn({
            addressCheckMethodType: "NBN_LOCATION_ID",
            addressValue: {
              LocationId: vm.nbnOrder.locationId
            },
            customerAuthorityDate: customerAuthorityDate
          });
          if (result.success) {
            var sqv3Result = result.data.sqv3;
            if (vm.isTransferred(sqv3Result)) {
              const reversalResult = await vm.ReverseTransferService({
                orderId: vm.nbnOrder.nbnOrderId,
                id: vm.nbnOrder.id
              });

              vm.setHttpResponse({
                text: reversalResult.message,
                color: reversalResult.success ? "success" : "error"
              });
            } else {
              vm.setHttpResponse({
                text: `Service is NOT ready for transfer`,
                color: "error"
              });
            }
          }
        } catch (e) {
          vm.setHttpResponse({
            text: e.message,
            color: "error"
          });
        } finally {
          vm.setProcessInactive();
        }
      } else {
        vm.setHttpResponse({
          text: "Reversal feature should only be available for 5 days",
          color: "error"
        });
      }

      //
    },
    editForm() {
      let vm = this;
      vm.setEditForm(true);
    },
    openCorrection() {
      this.showCorrectionForm = true;
    },
    closeCorrection() {
      this.showCorrectionForm = false;
    },
    onOrderCorrected(updatedOrder) {
      if (updatedOrder) {
        this.setNbnOrderDetails(Object.assign({}, this.nbnOrderRecord, updatedOrder));
      }
      this.showCorrectionForm = false;
    },

    getRealizedResource() {
      let vm = this;

      if (vm.orderItem.productType === "Fixed Wireless") {
        const ntdId = vm.nbnOrder.ntdId || vm.orderItem.ntdId;
        const ntdModifications =
          vm.nbnOrder.ntdModifications || vm.orderItem.ntdModifications;
        const ntdType = vm.nbnOrder.ntdType || vm.orderItem.ntdType;

        let resource = [
          {
            product: {
              productSpecification: {
                id: "NTD",
                version: "2.0.0",
                specificationType: "Resource Specification"
              }
            }
          },
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "UNID",
                version: "2.0.0",
                specificationType: "Resource Specification"
              },
              portId: vm.realizedResource.portId,
              speedAndDuplex:
                "Auto Negotiation (10/100/1000Mbps, Half/Full Duplex)"
            }
          }
        ];

        if (
          ntdId != null &&
          ntdId !== "" &&
          ntdId !== "NTD Installation Required" &&
          ntdId !== "Additional NTD Required" &&
          ntdId !== "Additional Line Installation"
        ) {
          if (
            ntdModifications == "" ||
            ntdModifications == "USE SELECTED NTD"
          ) {
            resource[0].action = "NO CHANGE";
            resource[0].product.id = ntdId;
          } else if (ntdModifications == "REQUEST NEW NTD") {
            resource[0].action = "ADD";
            resource[0].product.ntdType = normalizeFixedWirelessNtdType(
              ntdType
            );
          } else if (ntdModifications == "REPLACE SELECTED NTD") {
            resource[0].action = "ADD";
            resource[0].product.ntdType = normalizeFixedWirelessNtdType(
              ntdType
            );
          }
        } else {
          resource[0].action = "ADD";
          resource[0].product.ntdType = normalizeFixedWirelessNtdType(
            ntdType
          );
        }

        if (vm.orderItem.tagVlan != null && vm.orderItem.tagVlan !== "") {
          resource[1].product.vlanMode = "Tagged";
        }
        return resource;
      } else if (vm.orderItem.productType === "HFC") {
        let resource = [
          {
            product: {
              productSpecification: {
                id: "NTD",
                version: "8.0",
                specificationType: "Resource Specification"
              }
            }
          },
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "UNID",
                version: "1.0",
                specificationType: "Resource Specification"
              },
              portId: vm.realizedResource.portId
            }
          }
        ];

        applyNtdRealizedResource(
          resource[0],
          {
            ...vm.orderItem,
            ntdModifications:
              vm.orderItem.ntdId === "NTD Installation Required"
                ? NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
                : vm.orderItem.ntdId === "Additional NTD Required" ||
                  vm.orderItem.ntdId === "Additional Line Installation"
                ? NTD_MODIFICATION_OPTIONS.REQUEST_NEW
                : vm.orderItem.replaceNtd
                ? NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
                : vm.orderItem.ntdModifications ||
                  (resolveExistingNtdId(vm.orderItem, vm.sqNbnResult)
                    ? NTD_MODIFICATION_OPTIONS.USE_SELECTED
                    : NTD_MODIFICATION_OPTIONS.REQUEST_NEW)
          },
          vm.sqNbnResult,
          "NTD_2.5"
        );

        if (
          resource[0].action === "ADD" &&
          !resource[0].product.id &&
          !resource[0].product.location
        ) {
          resource[0].product.location = "Indoor";
        }

        if (vm.orderItem.installationWorkforce === "RSP Install End User") {
          resource[0].product.macAddress = vm.orderItem.macAddress;
          resource[0].product.serialNumber = vm.orderItem.serialNumber;
        }

        if (vm.orderItem.tagVlan != null && vm.orderItem.tagVlan !== "") {
          resource[1].product.vlanMode = "Tagged";
        }
        return resource;
      } else if (vm.orderItem.productType === "Enterprise Ethernet") {
        return [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "BTD",
                version: "1.0.0",
                specificationType: "Resource Specification"
              },
              preferredBTDMounting: vm.realizedResource.preferredBTDMounting,
              preferredPowerSupply1: vm.realizedResource.preferredPowerSupply1,
              btdType: "Standard"
            }
          },
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "UNI-E",
                version: "1.0.0",
                specificationType: "Resource Specification"
              },
              interfaceBandwidth: {
                amount: vm.realizedResource.interfaceBandwidth.split(" ")[0],
                unit: "Gbps"
              },
              interfaceType: vm.realizedResource.interfaceType,
              ovcType: vm.realizedResource.ovcType,
              tpid: vm.realizedResource.tpid
            }
          }
        ];
      } else if (
        vm.orderItem.productType === "FTTC" ||
        vm.orderItem.productType === "FTTB" ||
        vm.orderItem.productType === "FTTN"
      ) {
        let resource = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "UNI-DSL",
                version: "12",
                specificationType: "Resource Specification"
              },
              dslMode: "VDSL2"
            }
          }
        ];

        if (
          vm.orderItem.productType === "FTTB" ||
          vm.orderItem.productType === "FTTN"
        ) {
          resource[0].product.dslStabilityProfile = "Standard";
        }

        if (
          vm.orderItem.cpiId != null &&
          vm.orderItem.cpiId !== "" &&
          vm.orderItem.cpiId !== "Additional Line Installation" &&
          vm.orderItem.cpiId !== "New Line Installation"
        ) {
          resource[0].action = "MODIFY";
          resource[0].product.id = vm.orderItem.cpiId;
        } else {
          resource[0].action = "ADD";
        }

        if (vm.orderItem.orderType === "Transition") {
          resource[0].product.potsInterconnect = vm.orderItem.potsInterconnect;
          resource[0].product.exchangePairConnection = "Yes";
        }

        if (vm.orderItem.tagVlan != null && vm.orderItem.tagVlan !== "") {
          resource[0].product.vlanMode = "Tagged";
        }

        return resource;
      } else if (isFibreProductType(vm.orderItem.productType)) {
        let resource = [
          {
            product: {
              productSpecification: {
                id: "NTD",
                version: "1.0",
                specificationType: "Resource Specification"
              }
            }
          },
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "UNID",
                version: "1.0",
                specificationType: "Resource Specification"
              },
              portId: vm.realizedResource.portId
              // speedAndDuplex:
              //   vm.getSpeedAndDuplex(),
              // interfaceType:
              //   vm.getInterfaceType()
            }
          }
        ];

        applyNtdRealizedResource(
          resource[0],
          {
            ...vm.orderItem,
            ntdModifications:
              vm.orderItem.ntdId === "NTD Installation Required"
                ? NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
                : vm.orderItem.ntdId === "Additional NTD Required" ||
                  vm.orderItem.ntdId === "Additional Line Installation"
                ? NTD_MODIFICATION_OPTIONS.REQUEST_NEW
                : vm.orderItem.ntdModifications ||
                  (resolveExistingNtdId(vm.orderItem, vm.sqNbnResult)
                    ? NTD_MODIFICATION_OPTIONS.USE_SELECTED
                    : NTD_MODIFICATION_OPTIONS.REQUEST_NEW)
          },
          vm.sqNbnResult,
          "4_PORT"
        );

        if (vm.orderItem.tagVlan != null && vm.orderItem.tagVlan !== "") {
          resource[1].product.vlanMode = "Tagged";
        }

        return resource;
      }
      return null;
    },
    getRealizedService() {
      let vm = this;
      var services = [];
      if (vm.orderItem.productType === "Fixed Wireless") {
        services = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "AVCD",
                version: "2.0.0",
                specificationType: "Service Specification"
              },
              bandwidthProfile: vm.realizedService.bandwidthProfile,
              cvcId:
                process.env.NODE_ENV == "staging" ||
                process.env.NODE_ENV == "development"
                  ? "CVC000000752699"
                  : vm.cvcId,
              nniCvlanId: "0"
            }
          }
        ];
      } else if (vm.orderItem.productType === "HFC") {
        services = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "AVCD",
                version: "1.0",
                specificationType: "Service Specification"
              },
              bandwidthProfile: vm.realizedService.bandwidthProfile,
              cvcId:
                process.env.NODE_ENV == "staging" ||
                process.env.NODE_ENV == "development"
                  ? "CVC000000752699"
                  : vm.cvcId,
              nniCvlanId: "0",
              accessLoopIdentification: "Active"
            }
          }
        ];
      } else if (vm.orderItem.productType === "Enterprise Ethernet") {
        services = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "OVC",
                version: "1.0.0",
                specificationType: "Service Specification"
              },
              routeType: vm.realizedService.routeType,
              nniGroupId: vm.realizedService.nniGroupId,
              cosHighBandwidth: {
                amount: vm.realizedService.cosHighBandwidth.split(" ")[0],
                unit: "Mbps"
              },
              mappingMode: vm.realizedService.mappingMode,
              ovcTransientId: vm.realizedService.ovcTransientId,
              connectedToUni: "UNI-E1"
            }
          },
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "OVC",
                version: "1.0.0",
                specificationType: "Service Specification"
              },
              routeType: vm.realizedService.routeType,
              nniGroupId: vm.realizedService.nniGroupId,
              cosHighBandwidth: {
                amount: vm.realizedService.cosHighBandwidth.split(" ")[0],
                unit: "Mbps"
              },
              mappingMode: vm.realizedService.mappingMode,
              ovcTransientId: "OVC-2",
              connectedToUni: "UNI-E1"
            }
          }
        ];
      } else if (
        vm.orderItem.productType === "FTTC" ||
        vm.orderItem.productType === "FTTN" ||
        vm.orderItem.productType === "FTTB"
      ) {
        services = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "AVCD",
                version: "1.0",
                specificationType: "Service Specification"
              },
              bandwidthProfile: vm.realizedService.bandwidthProfile,
              cvcId:
                process.env.NODE_ENV == "staging" ||
                process.env.NODE_ENV == "development"
                  ? "CVC000000752699"
                  : vm.cvcId,
              nniCvlanId: "0",
              accessLoopIdentification: "Active"
            }
          }
        ];
      } else if (isFibreProductType(vm.orderItem.productType)) {
        services = [
          {
            action: "ADD",
            product: {
              productSpecification: {
                id: "AVCD",
                version: "1.0",
                specificationType: "Service Specification"
              },
              bandwidthProfile: vm.realizedService.bandwidthProfile,
              cvcId:
                process.env.NODE_ENV == "staging" ||
                process.env.NODE_ENV == "development"
                  ? "CVC000000752699"
                  : vm.cvcId,
              nniCvlanId: "0"
            }
          }
        ];
      }

      if (
        vm.orderItem.productType !== "Enterprise Ethernet" &&
        vm.orderItem.tagVlan != null &&
        vm.orderItem.tagVlan !== ""
      ) {
        services[0].product.uniVlanId = vm.orderItem.tagVlan;
      }
      return services;
    },
    setNbnOrderItem(payload, options = {}) {
      let vm = this;

      vm.orderItem = payload;

      if (vm.isLayer3) {
        if (
          vm.nbnOrder.radiusUsername === null ||
          vm.nbnOrder.radiusUsername.length <= 0 ||
          !vm.nbnOrder.radiusUsername.trim()
        )
          vm.isRadiusExisting = false;
        else {
          vm.checkRadiusUsername(vm.nbnOrder.radiusUsername).then(data => {
            vm.isRadiusExisting = data;
          });
        }
      }

      if (
        payload.orderType != null &&
        payload.orderType !== "Connect" &&
        payload.orderType !== "Transfer" &&
        payload.orderType !== "Transition"
      ) {
        vm.isConnectOrder = false;
        vm.isTransferOrder = false;
        vm.isTransitionOrder = false;
      } else {
        vm.isConnectOrder = payload.orderType === "Connect";
        vm.isTransferOrder = payload.orderType === "Transfer";
        vm.isTransitionOrder = payload.orderType === "Transition";
      }

      if (
        (payload.ntdId != null &&
          payload.ntdId !== "" &&
          payload.ntdId !== "NTD Installation Required") ||
        (payload.existingNtdId != null && payload.existingNtdId !== "")
      ) {
        vm.hasNtdId = true;
      }
      if (!options.skipReset) {
        vm.realizedResource = {};
        vm.realizedService = {};
        if (vm.$refs.realizedServices !== undefined) {
          vm.$refs.realizedServices.resetForm();
        }

        if (vm.$refs.realizedResource !== undefined) {
          vm.$refs.realizedResource.resetForm();
        }
      }

      vm.$emit("orderTypeChanged");
      setTimeout(() => {
        vm.$refs.observer.validate();
      }, 100);
    },
    setStaticIp() {
      let vm = this;
      vm.$refs.nbnOrderItem.setStaticIpByRadiusName();
    },
    setNbnRealizedResource(payload) {
      let vm = this;
      vm.realizedResource = payload;
    },
    setNbnRealizedService(payload) {
      let vm = this;
      vm.realizedService = payload;
    },
    onTriggerCancel() {
      let vm = this;
      vm.cancelDialog = true;
    },
    onTriggerDisconnect() {
      let vm = this;
      vm.disconnectDialog = true;
    },
    onTriggerActivate() {
      let vm = this;
      vm.activateDialog = true;
    },
    onTriggerServiceRestoration() {
      let vm = this;
      vm.showNewNbnTicket = true;
      vm.$refs.ticketForm.setWholesaler(vm.wholesalerAccount);
    },
    onTriggerTransferLossRemove() {
      let vm = this;
      vm.transferLossRemoveDialog = true;
    }
  },
  computed: {
    isCpiAvailable() {
      let vm = this;

      return (
        vm.orderItem.productType === "FTTB" ||
        vm.orderItem.productType === "FTTN" ||
        vm.orderItem.productType === "FTTC"
      );
    },
    isNCAS() {
      let vm = this;
      if (
        vm.newOrder.productType != null &&
        (vm.newOrder.productType === "FTTB" ||
          vm.newOrder.productType === "FTTN" ||
          vm.newOrder.productType === "FTTC")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEE() {
      let vm = this;
      if (
        vm.newOrder.productType != null &&
        vm.newOrder.productType === "Enterprise Ethernet"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showConnectOutstandingFeature() {
      let vm = this;
      var show = false;
      if (vm.isAdmin) show = true;
      else {
        if (vm.isInternalWholesaler) show = true;
        else show = false;
      }
      return show;
    },
    productType() {
      const vm = this;
      return vm.nbnOrder.productType;
    }
  }
};
</script>

<style scoped></style>
